import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import useResponsive from '@/components/hooks/useResponsive';
import useTestFlags from '@/components/hooks/useTestFlags';
import Header from '@/components/pages/visitorHome/GreaterCareLayout/Hero/Header';
import HomePageFooter from '@/components/shared/HomePageFooter';
import { CLIENT_FEATURE_FLAGS, UNKNOWN_VERTICAL } from '@/constants';
import MemberSelection from '@/components/shared/MemberSelection';
import { AnalyticsHelper } from '@/utilities/AnalyticsHelper';
import Animation from './Animation/Animation';
import Pricing from './Pricing/Pricing';
import Testimonials from './Testimonials/Testimonials';
import FAQS from './FAQS/FAQS';
import Hero from './Hero/Hero';
import Safety from './Safety/Safety';
import GettingStarted from './GettingStarted/GettingStarted';

const PlansAndPricingPage = () => {
  const { isDesktop } = useResponsive();
  const [openModalOrDrawer, setOpenModalOrDrawer] = useState<boolean>(false);
  const { adultCareRoutesFlag } = useTestFlags();
  const pricingScroll = useRef<HTMLDivElement>(null);
  const testimonialsScroll = useRef<HTMLDivElement>(null);
  const faqScroll = useRef<HTMLDivElement>(null);

  useEffect(() => {
    AnalyticsHelper.logTestExposure(CLIENT_FEATURE_FLAGS.ADULT_CARE_ROUTES, adultCareRoutesFlag);
  }, [adultCareRoutesFlag]);

  const handleScrollToPricing = () => {
    if (pricingScroll.current) {
      pricingScroll.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (pricingScroll.current && window.location.hash === '#pricing') {
      pricingScroll.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  useEffect(() => {
    if (testimonialsScroll.current && window.location.hash === '#testimonials') {
      testimonialsScroll.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  useEffect(() => {
    if (faqScroll.current && window.location.hash === '#faq') {
      faqScroll.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <Box>
      <Header />
      <Hero onExplorePlansClick={handleScrollToPricing} />
      <Animation />

      <Box ref={pricingScroll}>
        <Pricing setOpenModalOrDrawer={setOpenModalOrDrawer} />
      </Box>

      <Safety />

      <GettingStarted setOpenModalOrDrawer={setOpenModalOrDrawer} />

      <Box ref={testimonialsScroll}>
        <Testimonials setOpenModalOrDrawer={setOpenModalOrDrawer} />
      </Box>

      <Box ref={faqScroll}>
        <FAQS />
      </Box>

      <HomePageFooter renderDesktopView={isDesktop} />

      <MemberSelection
        selectedVertical={UNKNOWN_VERTICAL}
        openModalOrDrawer={openModalOrDrawer}
        setOpenModalOrDrawer={setOpenModalOrDrawer}
      />
    </Box>
  );
};

export default PlansAndPricingPage;
